// extracted by mini-css-extract-plugin
export default {"btn":"Checkout_btn__KSbYW","headerTable":"Checkout_headerTable__fXXFi","bodyTable":"Checkout_bodyTable__fCHvH","label":"Checkout_label__45x3V","header":"Checkout_header__Vmfvb"};